import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Paper,
  Typography,
} from "@mui/material";
import { mainTextColor } from "./colorPalette";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { putChatManualConfirmStatus } from "./putChatManualConfirmStatus";

export const ChatDescriptionPage = () => {
  const navigate = useNavigate();
  const { user } = useAuthenticator((context) => [context.user]);
  const location = useLocation();
  const state = location.state as {
    date?: string;
  };

  const { idToken, refreshAuthSession } = useAuth();

  const [checkedConfirm, setCheckedConfirm] = useState<boolean>(false);

  const navigateToChat = () => {
    // 直リンク等でアクセスした場合は弾く
    if (!state.date) return;
    if (!idToken) return;

    if (checkedConfirm) {
      putChatManualConfirmStatus({ userId: user.userId }, idToken);
    }

    navigate("/chat", {
      state: { complete: false, conversationDate: state.date },
    });
  };

  const handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log(user.userId);
    console.log(state.date);
    setCheckedConfirm(event.target.checked);
  };

  return (
    <>
      <Box sx={{ m: 3, color: mainTextColor }}>
        <Paper sx={{ p: 2 }}>
          <Typography variant="h6">チャット画面の使い方</Typography>
          <div style={{ height: "1.5rem" }} />
          <Typography variant="body2">
            先ほど思い出した『ポジティブな出来事』について、チャットボットが質問を行います。
            あなたは、その出来事を話題に自由に会話を行ってください。
          </Typography>
          <div style={{ height: "1rem" }} />
          <Typography variant="body2">
            会話を終える際には
            上部にある『会話を終了する』ボタンから終了してください。
          </Typography>
          <div style={{ height: "0.5rem" }} />
          <img src="./chatManualImages/img001.jpg" />
          <div style={{ height: "0.5rem" }} />
          <Typography variant="body2">
            会話は、あなたの任意のタイミングで終了して頂いて構いません。
          </Typography>
          <div style={{ height: "1rem" }} />
          <Typography variant="body2">
            途中で画面を切り替えてしまったときでも会話は保存され、続きからチャットを行うことが可能です。
          </Typography>
          <Typography variant="body2">
            ただし、必ず『会話を終了する』ボタンで終了の処理を行うようにしてください。
          </Typography>
          <div style={{ height: "1rem" }} />
          <Typography variant="body2">
            会話内容は、1日毎にリセットされます。
          </Typography>
          <div style={{ height: "2rem" }} />
          <FormGroup>
            <FormControlLabel
              control={<Checkbox onChange={handleCheckBoxChange} />}
              label="次回から表示しない"
            />
          </FormGroup>
          <div style={{ height: "1rem" }} />
          <Button onClick={navigateToChat}>チャットへ進む</Button>
        </Paper>
      </Box>
    </>
  );
};
